import styled from 'styled-components';

export const AuthContainer = styled.main`
  min-height: 100vh;
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: var(--space-xxl);

  background: radial-gradient(
      circle at top right,
      rgba(255, 210, 66, 0.08),
      transparent 28%
    ),
    linear-gradient(180deg, var(--white) 0%, var(--cardBackground) 100%);

  a {
    color: var(--orange5);
    text-decoration: none;
    font-weight: 800;
    letter-spacing: 0;
    font-size: var(--space-m);

    &:hover {
      text-decoration: underline;
    }
  }

  @media screen and (max-width: 1150px) {
    padding: var(--space-xl);
  }

  @media screen and (max-width: 600px) {
    padding: var(--space-m);
    align-items: flex-start;
  }
`;

export const AuthContainer2 = styled.section`
  width: min(100%, 1120px);
  min-height: 720px;

  display: grid;
  grid-template-columns: 0.9fr 1.1fr;

  background: var(--white);

  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 28px;

  overflow: hidden;

  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.1);

  @media screen and (max-width: 1150px) {
    width: min(100%, 680px);
    min-height: auto;

    grid-template-columns: 1fr;
  }

  @media screen and (max-width: 600px) {
    border-radius: 20px;
  }
`;

export const PictureSide = styled.section`
  min-height: 100%;

  display: flex;

  background: #000;

  img {
    width: 100%;
    height: 100%;

    display: block;

    object-fit: cover;
    object-position: center;

    opacity: 0.92;
  }

  @media screen and (max-width: 1150px) {
    display: none;
  }
`;

export const AuthenticationSide = styled.section`
  min-height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  padding: var(--space-xxxl);

  background: linear-gradient(180deg, var(--offWhite) 0%, var(--white) 100%);

  form {
    width: 100%;
    max-width: 460px;

    display: flex;
    flex-direction: column;
  }

  form button {
    width: 100%;
    max-width: none;

    margin-top: var(--space-s);
  }
  .success {
    margin: var(--space-xs) 0 0;

    padding: var(--space-s) var(--space-m);

    border-radius: var(--borderRadius);

    background: var(--lightGreen);
    color: var(--successGreen);

    font-size: 0.9rem;
    line-height: 1.5;
    font-weight: 700;
  }
  .error {
    margin: var(--space-xs) 0 0;

    padding: var(--space-s) var(--space-m);

    border-radius: var(--borderRadius);

    background: var(--lightRed);
    color: var(--errorRed);

    font-size: 0.9rem;
    line-height: 1.5;
    font-weight: 700;
  }

  @media screen and (max-width: 1150px) {
    padding: var(--space-xxl);

    background: var(--white);
  }

  @media screen and (max-width: 600px) {
    padding: var(--space-l);
  }
`;

export const AuthHeader = styled.div`
  margin-bottom: var(--space-xl);

  h2 {
    margin: var(--space-xs) 0 var(--space-s);

    color: var(--grey7);

    font-size: clamp(2rem, 4vw, 3rem);
    line-height: 1;
    font-weight: 900;

    letter-spacing: -0.04em;
  }

  p:not(.eyebrowHeader) {
    margin: 0;

    color: var(--grey4);

    font-size: 0.98rem;
    line-height: 1.7;
    font-weight: 500;
  }
`;

export const EachInput = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  width: 100%;

  gap: var(--space-xxs);

  margin-bottom: var(--space-m);

  label {
    color: var(--grey6);

    font-size: 0.9rem;
    font-weight: 800;

    margin-bottom: var(--space-xxs);
  }

  input {
    width: 100%;
    max-width: 100%;
    min-width: 100%;

    padding: var(--space-s) var(--space-m);

    border: 1px solid var(--grey1);
    border-radius: var(--borderRadius);

    background: var(--white);

    color: var(--grey7);

    font-size: var(--space-m);

    transition:
      border-color 0.2s ease,
      box-shadow 0.2s ease;

    &:focus {
      outline: none;

      border-color: var(--orange4);

      box-shadow: 0 0 0 4px rgba(242, 175, 23, 0.12);
    }
  }

  span {
    color: var(--grey3);

    font-size: 0.82rem;
    line-height: 1.5;
    font-weight: 500;
  }

  .passwordSwitch {
    color: var(--grey5);

    font-size: 0.85rem;
    font-weight: 800;

    text-decoration: none;

    cursor: pointer;

    &:hover {
      color: var(--orange5);
    }
  }

  .passwordContainer {
    width: 100%;

    display: flex;
    justify-content: space-between;
    align-items: center;

    gap: var(--space-xs);
  }

  .passwordIcon {
    min-width: 32px;

    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const OptionsContainer = styled.div`
  width: 100%;
  max-width: 460px;

  margin-top: var(--space-l);
  padding-top: var(--space-l);

  display: flex;
  flex-direction: column;
  gap: var(--space-s);

  border-top: 1px solid var(--grey1);
`;

export const SwitchPage = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-m);

  padding: var(--space-s) 0;

  p {
    margin: 0;

    color: var(--grey4);

    font-size: 0.92rem;
    line-height: 1.5;
    font-weight: 500;
  }

  button {
    padding: 0;
    min-width: auto;
    width: auto;

    white-space: nowrap;
  }

  @media screen and (max-width: 600px) {
    align-items: flex-start;
    flex-direction: column;
    gap: var(--space-xxs);
  }
`;

export const NameFieldsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--space-m);

  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
    gap: 0;
  }
`;

export const LegalText = styled.span`
  display: block;

  margin-top: var(--space-m);

  color: var(--grey4);

  text-align: center;

  font-size: 0.82rem;
  line-height: 1.6;
  font-weight: 500;

  a {
    color: var(--orange5);
    font-size: inherit;
    font-weight: 800;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;
